import {
  NOTIFICTION_LIST_F,
  NOTIFICTION_LIST_S,
  NOTIFICTION_REMOVE,
} from "../constants/types";

const initialState = {
  notifictionlist: [],
};

const NotifictionReducer = (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICTION_LIST_S:
      const rows = Array.isArray(action.payload?.data)
        ? action.payload.data
        : [];
      let list;
      if (action.payload.reset === true) {
        list = rows;
      } else {
        // Skip rows already in the list (e.g. a repeated scroll request).
        const seen = new Set(state.notifictionlist.map((n) => n?._id));
        list = [
          ...state.notifictionlist,
          ...rows.filter((n) => !seen.has(n?._id)),
        ];
      }
      return {
        ...state,
        loading: false,
        error: null,
        message: action.payload.message,
        notifictionlist: list,
      };
    case NOTIFICTION_LIST_F:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        message: action?.payload?.message,
      };
    case NOTIFICTION_REMOVE:
      return {
        ...state,
        notifictionlist: state.notifictionlist.filter(
          (n) => n?._id !== action.payload
        ),
      };
    default:
      return state;
    // case HOMEPAGE_DETAIL_S:
    //     return {
    //         ...state, homepagedetail: action.payload.data
    //     }
    // case HOMEPAGE_UPDATE_F:
    //     return {
    //         ...state, homepagedetail: action.payload.message
    //     }
  }
};
export default NotifictionReducer;
